import { Abwesenheit } from './Abwesenheit';
import { Arbeitszeit } from './Arbeitszeit';
import { BaseRow } from './BaseRow';
import { RowTypeMap } from './Entities';

export class Konflikt extends BaseRow {
  readonly _type: keyof RowTypeMap = 'konflikt';
  readonly rootArbeitszeit: Arbeitszeit | Abwesenheit;
  readonly conflictCause: Abwesenheit | Arbeitszeit | Abwesenheit | null;

  constructor({
    arbeitszeit,
    conflictCause,
  }: {
    arbeitszeit: Arbeitszeit | Abwesenheit;
    conflictCause: Abwesenheit | Arbeitszeit | Abwesenheit | null;
  }) {
    super();
    this.rootArbeitszeit = arbeitszeit;
    this.conflictCause = conflictCause;
  }
}
